<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.833496 10C0.833496 4.9374 4.93755 0.833344 10.0002 0.833344C15.0628 0.833344 19.1668 4.9374 19.1668 10C19.1668 15.0626 15.0628 19.1667 10.0002 19.1667C4.93755 19.1667 0.833496 15.0626 0.833496 10ZM13.3093 14.2794C13.5772 14.5473 14.0116 14.5473 14.2795 14.2794C14.5474 14.0114 14.5474 13.577 14.2795 13.3091L10.6862 9.71583V5.78422C10.6862 5.40531 10.3791 5.09814 10.0002 5.09814C9.62126 5.09814 9.31409 5.40531 9.31409 5.78422V10C9.31409 10.182 9.38637 10.3565 9.51504 10.4851L13.3093 14.2794Z"
      fill="white"
    />
  </svg>
</template>
